import { Card, Text, TextAlignment, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import { CheckmarkCircle, CheckmarkCircleFilled } from '@volkswagen-onehub/icons-core';
import React from 'react';
import { COLOR_TOKEN, STYLED_INPUT } from '../../../../constants/styles-constants';

interface Props {
	title?: React.ReactNode;
	text?: React.ReactNode;
	index?: React.ReactNode;
	icon?: React.ReactElement;
	children?: React.ReactNode;
	disabled?: boolean;
	isActive?: boolean;
	hasError?: boolean;
	selectable?: boolean;
	dataAttributes?: Record<string, string | number | undefined>;
	onSelect?: () => void;
}

export function OptionCard(props: Props) {
	const {
		title,
		text,
		index,
		icon,
		children,
		disabled,
		isActive = false,
		hasError = false,
		selectable = true,
		dataAttributes,
		onSelect,
	} = props;

	const hasBody = !!text || children != null;

	return (
		<Card
			className="card"
			{...dataAttributes}
			style={{
				marginLeft: STYLED_INPUT.margin.left,
				marginRight: STYLED_INPUT.margin.right,
				height: '100%',
			}}
			{...(selectable
				? {
						type: 'selectable' as const,
						tabIndex: 0,
						isActive,
						disabled,
						onToggle: () => onSelect?.(),
						onKeyDown: (e: React.KeyboardEvent) => {
							if (e.key === 'Enter' || e.key === ' ') {
								e.preventDefault();
								onSelect?.();
							}
						},
					}
				: { type: 'default' as const })}
			{...(hasError &&
				({
					style: {
						outline: '3px solid ' + COLOR_TOKEN.displayTag.error.background,
						outlineOffset: '-3px',
						marginLeft: STYLED_INPUT.margin.left,
						marginRight: STYLED_INPUT.margin.right,
					},
				} as any))}
		>
			<div
				style={{
					display: 'flex',
					cursor: selectable ? 'pointer' : undefined,
					alignItems: hasBody ? 'flex-start' : 'center',
				}}
			>
				<div style={{ width: '40px' }}>
					{isActive ? (
						<div style={{ color: COLOR_TOKEN.border.active }}>
							<CheckmarkCircleFilled />
						</div>
					) : (
						(icon ?? <CheckmarkCircle />)
					)}
				</div>
				<div style={{ width: 'calc(100% - 40px)' }}>
					{title != null && (
						<div
							style={{
								display: 'flex',
								flexDirection: 'row',
								marginBottom: '5px',
							}}
						>
							<Text bold appearance={TokenTextAppearance.headline100}>
								{title}
							</Text>
							{index != null && (
								<div
									style={{
										minWidth: '70px',
										marginLeft: 'auto',
									}}
								>
									<Text bold appearance={TokenTextAppearance.headline100} textAlign={TextAlignment.right}>
										{index}
									</Text>
								</div>
							)}
						</div>
					)}
					{children ?? (text && <Text appearance={TokenTextAppearance.copy100}>{text}</Text>)}
				</div>
			</div>
		</Card>
	);
}
